module.exports = __webpack_public_path__ + "img/RareDangPacks.7fadbdce.png";